import { TipoTopicoNotificacaoEnum } from 'graphql/types.generated'
import Permissions, { Permission } from 'types/Permissions'

export type NotificacaoCountContextModel = Record<TipoTopicoNotificacaoEnum, number>

export const defaultCountTipoNotificacaoRecord: NotificacaoCountContextModel = {
  [TipoTopicoNotificacaoEnum.CUIDADO_COMPARTILHADO]: 0,
  [TipoTopicoNotificacaoEnum.REGULACAO_ASSISTENCIAL]: 0,
}

export const permissaoPorTipoTopicoNotificacaoRecord: Record<TipoTopicoNotificacaoEnum, Permission> = {
  [TipoTopicoNotificacaoEnum.CUIDADO_COMPARTILHADO]: Permissions.cuidadoCompartilhado,
  [TipoTopicoNotificacaoEnum.REGULACAO_ASSISTENCIAL]: Permissions.visualizarProntuario,
}

export type OperacaoNotificacao = 'ADD' | 'SUB'

export interface NotificacaoDeltaAtmosphereResponse {
  operacao: OperacaoNotificacao
  valor: number
  tipoNotificacao: TipoTopicoNotificacaoEnum
}

export type NotificacaoDeltaAtmosphereResponseList = NotificacaoDeltaAtmosphereResponse[]
